import * as React from 'react'

import { BaseIcon/*, Props*/ } from './BaseIcon'

export class Caret extends BaseIcon {
 /*constructor (props: Props) {
    super(props)
  }*/
  public render () {
    const className = this.props.className ? `${this.defaults.className} ${this.getSize()} ${this.props.className}`
      : `${this.defaults.className} ${this.getSize()}`

    const viewBox = this.props.viewBox ? this.props.viewBox : this.defaults.viewBox

    // tslint:disable    
    return (
      <div>
        <svg xmlns="http://www.w3.org/2000/svg"  className={className} fill="none" viewBox={viewBox} id="Arrow-Button-Up">
        <path strokeLinecap="round" strokeLinejoin="round" d="M4.9753 18.8302 12 12.0005l7.0247 6.8297c0.2983 0.287 0.77 0.287 1.0683 0l2.7107 -2.6353c0.2951 -0.2837 0.2951 -0.756 0 -1.0398L12.5341 5.16979c-0.2982 -0.287 -0.77 -0.287 -1.0682 0L1.1963 15.1552c-0.295099 0.2837 -0.295099 0.756 0 1.0397l2.7108 2.6353c0.2982 0.287 0.7699 0.287 1.0682 0Z" strokeWidth="1.5"></path></svg>
      </div>
    )
 }
}
export default Caret